// extracted by mini-css-extract-plugin
var _1 = "SearchSectionHeader-moduleSearchSectionHeader__c9B21";
var _2 = "SearchSectionHeader-moduletitle__dkd0x SearchSectionTitle-moduleSearchSectionTitle__dPlCi";
export { _1 as "SearchSectionHeader", _2 as "title" }
